import PostSummaryList from "../PostSummaryList/index.js";
import React from "react";

const ExploreComponent = () => {
  return(
      <div>
            <div className={`container`}>
              <div className={`container mt-2`}>
                <div className={`row mb-2`}>
                  <div className={`col-10`}>
                    <div className={`container`}>
                      <div className={`position-absolute`}>
                        <input className={`wd-search-twitter type=text style=width: calc(100%) placeholder= "        Search Twitter`}/>
                        <i className={`fa fa-search wd-gray wd-magnifier-glass wd-icons mt-2`}/>
                      </div>
                    </div>
                  </div>
                  <div className={`col-2`}>
                    <div className={`container`}>
                      <a href={`explore-settings.html`}> <i className={`fas fa-cog fa-2x`} ></i></a>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`row`}>
                <div className={`col-12`}>
                  <div className={`container `}>
                    <div className={`col-auto`}>
                      <ul className={`nav mb-2 nav-tabs`}>
                        <li className={`nav-item`}>
                          <a className={`nav-link active text-white text-primary border-0`} href={'#top'}>For you</a>
                        </li>
                        <li className={`nav-item`}>
                          <a className={`nav-link text-white`} href={'#:;'}>Trending</a>
                        </li>
                        <li className={`nav-item`}>
                          <a className={`nav-link text-white`} href={'#top'}>News</a>
                        </li>
                        <li className={`nav-item`}>
                          <a className={`nav-link text-white`} href={'#top'}>Sports</a>
                        </li>
                        <li className={`nav-item d-sm-none d-md-block d-lg-block d-xl-block d-xxl-block`}>
                          <a className={`nav-link text-white`} href={'#top'}>Entertainment</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`row`}>
                <div className={`col`}>
                  <div className={`container`}>
                    <div className={`card mt-2 text-white`}>
                      <img
                        src="https://www.psu.com/wp/wp-content/uploads/2020/09/Overwatch-PS4-Wallpapers-75-768x432.jpg"
                        alt={'overwatch DVA'}
                       className={`card-img-top`}/>
                      <div className={`card-img-overlay d-flex flex-column justify-content-end`}>
                        <h3 className={`card-title`}>SpaceX's Starship</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
             {PostSummaryList()}
            </div>
      </div>
    );
}
export default ExploreComponent;

